import { render, staticRenderFns } from "./TTDeletedBetDetails.vue?vue&type=template&id=5fa5c3c5&scoped=true"
import script from "./TTDeletedBetDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./TTDeletedBetDetails.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.1_webpack@5.74.0_esbuild@0.28.1___lodash@4.17.21_pret_109f61365412ffe5355524363be3c32c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa5c3c5",
  null
  
)

export default component.exports